module.exports = __webpack_public_path__ + "b9b23a6aa77ac6b91fcce626cc4ff736.png";